module.exports = __webpack_public_path__ + "static/media/almonds.65e4743b.jpg";